/**
 * The Dual Layer IT logo for the ground it sits on (design system › Logos).
 *
 * - Light grounds: the colour logo (dark lettering, orange double-L).
 * - Dark grounds and the hull navigation chrome: the reverse logo (white
 *   lettering, orange double-L).
 * - Small spaces (collapsed sidebar, app tile): the square icon.
 *
 * The files ship with the app in public/brand and are never recoloured. The
 * logo uploaded under Admin → Branding is now used only on printed reports.
 *
 * The logo is the "DUALLAYER" wordmark only (October 2026); the legal name
 * stays in text. nginx serves SVGs as immutable for 30 days, so when the
 * artwork changes under the same file name, bump `v` or browsers keep the
 * old one.
 */
import { useThemeStore, resolveTheme } from '@/store/theme.store';

const LOGO_VERSION = '2';
export const LOGO_COLOUR  = `/brand/dual-layer-logo.svg?v=${LOGO_VERSION}`;
export const LOGO_REVERSE = `/brand/dual-layer-logo-reverse.svg?v=${LOGO_VERSION}`;
export const LOGO_ICON    = '/brand/dl-icon.svg';

/** The logo for a page ground that follows the app's light/dark theme. */
export function useThemedLogo(): string {
  const mode = useThemeStore(s => s.mode);
  return resolveTheme(mode) === 'dark' ? LOGO_REVERSE : LOGO_COLOUR;
}

/** For surfaces with their own theme, such as the Trust Centre reader. */
export function useLogoFor(theme: 'light' | 'dark'): string {
  return theme === 'dark' ? LOGO_REVERSE : LOGO_COLOUR;
}
